<template>
  <div class="task-card" :style="`border-left: ${color} solid 3px; cursor: pointer;`" @click="onOpen" v-touch:tap="onOpen">
    <div class="task-header">
      <div class="ellipsis__name" v-b-tooltip.hover :title="this.task.pessoa.nome" >
        <p class="task-name pointer" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
          <small style="vertical-align: middle; margin-right: .08rem; font-size: 12px;" v-if="personType == 'PF'" v-b-tooltip.hover title="Pessoa Física"><i class="fas fa-user"></i></small>
          <small style="vertical-align: middle; margin-right: .08rem; font-size: 12px;" v-else v-b-tooltip.hover title="Pessoa Jurídica"><i class="fas fa-building"></i></small>
          <span v-if="task && task.alreadyAssociate">
            <i class="fas fa-star text-warning" v-b-tooltip.hover title="Associado" style="font-size:11px;padding-bottom: 3px"></i>
            <span style="color: #2e6e60;">{{ this.task && this.task.pessoa && this.task.pessoa.nome ?
              this.task.pessoa.nome.toLowerCase()
              : 'N/D' }}</span>
          </span>
          <span v-else>{{ this.task && this.task.pessoa && this.task.pessoa.nome ? this.task.pessoa.nome.toLowerCase() : 'N/D' }}</span>
        </p>
        <p class="task-description" v-if="this.task.cardDetails.descricaoCard">{{ this.task.cardDetails.descricaoCard }}</p>
      </div>
      <!-- COMPONENT BELOW IS INACTIVE, BECAUSE OF TRIGGERING ISSUES -->
      <!-- <NxFupButton @click.prevent="onOpen(false)" v-touch:tap.prevent="onOpen(false)" v-touch:tap.stop="onOpen(false)" :task="this.task" :id="this.task.id"/> -->
    </div>
    <hr style="margin-top: 6px; margin-bottom: 10px;">
    <div class="task__card__body">
      <div class="d-flex justify-content-between w-100 ">
        <div class="" style="display: flex; gap: .15rem;">
          <NxBadge icon="fas fa-comments" :text="formatLastContact" tooltipText="Contatos | Último Contato" status="default" />
        </div>
        <div class="task__card__body__inside">
          <NxBadge v-if="task.dateIngressoBoard" icon="fas fa-columns" :text="formatDiffTime(task.dateIngressoBoard)" tooltipText="Tempo no quadro" :status="setBadgeStatus(task.dateDeadlineInBoard, task.dateNearDeadlineInBoard)" />
          <NxBadge v-if="task.dateIngressoBoardcolumn" icon="fas fa-pause" :text="formatDiffTime(task.dateIngressoBoardcolumn)" tooltipText="Tempo na etapa" :status="setBadgeStatus(task.dateDeadlineInBoardcolumn, task.dateNearDeadlineInBoardcolumn)" />
          <NxBadge icon="fas fa-headset" :text="task.cardDetails.ultimoContatoPositivo ? formatDiffTime(task.cardDetails.ultimoContatoPositivo) : formatDiffTime(task.dataCriacao)" :tooltipText="task.cardDetails.ultimoContatoPositivo ? 'Tempo desde o último contato positivo.' : 'Nenhum contato positivo realizado.' " :status="setBadgeStatus(task.cardDetails.deadlineContatoPositivo, task.cardDetails.nearDeadlineContatoPositivo)" />
        </div>
      </div>
      <div class="agendamento__badge__text" style="display: flex; gap: .15rem;">
        <NxBadge class="w-100" :class="(hasUtmCampaign || hasInternCampaign) ? 'icon__green' : ''" v-if="task.origemLead || task.campanhas.length" icon="fas fa-bullhorn" :text="formatTextOrigin()" :tooltipText="formatTooltipOrigin()" status="default" />
      </div>
    </div>
    <div class="task__card__footer">
      <div class="d-flex task__card__footer__avatar__container">
        <b-avatar v-for="(responsavel, index) in initials" :key="responsavel.nomeCompleto" variant="info" class="task-image ml-1"
        size="1.7rem" :text="responsavel.initials" v-b-tooltip.hover :title="responsavel.nomeCompleto" :style="`--n: ${index}; border: solid #e5e5e5 1px;`"></b-avatar>
      </div>
      <div class="task__card__footer__right__container">
        <NxBadge v-if="hasNewProduct" icon="fas fa-wallet" text="Novo" :tooltipText="`Produto: ${task.cardDetails.nomeUltimoProdutoAdicionado}`" status="green" />
        <BadgeAgendamento v-if="task.cardDetails.agendamento" :date="task.cardDetails.agendamento" />
      </div>
    </div>
  </div>
</template>
<script>
import BadgeAgendamento from '@/components/UI/badge-agendamento/BadgeAgendamento.vue'
import NxBadge from '@/components/nexum/components/badge/NxBadge.vue'
import NxFupButton from '@/components/nexum/components/buttons/NxFupButton.vue'

export default {
  name: 'TaskCard',
  data () {
    return {
      isDataAgendamentoToday: false
    }
  },
  components: { BadgeAgendamento, NxBadge, NxFupButton },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: 'green'
    },
    boardColumnId: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    boardPosition: {
      type: Number,
      required: true,
      default: 0
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    hoursUntilAlert: {
      type: Number,
      required: false,
      default: 365
    },
    hasObservation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    initials () {
      let initials = []

      if (this.task && this.task.responsaveis) {
        this.task.responsaveis.forEach((responsavel) => {
          if (responsavel.usuario && responsavel.usuario.nomePessoa) {
            const names = responsavel.usuario.nomePessoa.split(' ')

            if (names.length > 1) {
              initials.push({
                initials: names[0][0] + names[names.length - 1][0],
                nomeCompleto: responsavel.usuario.nomePessoa
              })
            } else if (names.length > 0) {
              initials.push({
                initials: names[0][0],
                nomeCompleto: responsavel.usuario.nomePessoa
              })
            }
          }
        })
      }

      return initials
    },
    personType: function () {
      let result = 'PF'
      if (this.task && this.task.pessoa && this.task.pessoa.tipoPessoa) {
        return this.task.pessoa.tipoPessoa
      } else {
        result = 'PF'
        if (this.task && this.task.pessoa && this.task.pessoa.document) {
          let doc = this.task.pessoa.document.replace('.', '')
          doc = doc.replace('.', '')
          doc = doc.replace('-', '')
          doc = doc.replace('/', '')

          if (doc.length > 11) {
            result = 'PJ'
          }
        }
      }
      return result
    },
    formatLastContact () {
      let months = ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

      let quantity = this.task.cardDetails.countContatos
      // let lastDate = ' - 01/12'
      let lastDate = new Date(this.task.cardDetails.ultimoContato)
      let formattedDate = ` - ${lastDate.getDate()}/${months[lastDate.getMonth()]}`

      return quantity + (this.task.cardDetails.ultimoContato ? formattedDate : '')
    },
    hasNewProduct () {
      const today = new Date()
      const lastProductDay = new Date(this.task.cardDetails.dataUltimoProdutoAdicionado)

      const differenceInHours = (today - lastProductDay) / 1000 / 60 / 60
      return differenceInHours < 24
    },
    hasUtmCampaign () {
      const utmAttributes = ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent', 'utmTerm']
      return utmAttributes.some(attribute => this.task[attribute])
    },
    hasInternCampaign () {
      return this.task.campanhas.length > 0
    },
    randomId () {
      return Math.random().toString(36)
    }
  },
  methods: {
    onOpen (bool) {
      if (bool === false) return
      this.$emit('Open', { cardID: this.task.id })
    },
    setBadgeStatus (deadline, nearDeadline) {
      let status = ['red', 'yellow', 'green', 'default']

      if (!deadline || !nearDeadline) return status[3]
      else if (this.isDeadlinePassed(deadline)) return status[0]
      else if (this.isDeadlinePassed(nearDeadline)) return status[1]
      else return status[2]
    },
    isDeadlinePassed (deadlineDate) {
      let today = new Date()
      let deadline = new Date(deadlineDate)
      return today > deadline
    },
    formatDiffTime (referenceDate) {
      if (referenceDate) {
        let diff = (new Date(referenceDate).getTime() - new Date().getTime()) / 1000
        diff = Math.abs(diff)
        if (diff < 60) return (Math.round(diff) + 's')
        else if (diff < 3600) {
          diff /= 60
          return (Math.round(diff) + 'min')
        } else if (diff < 86400) {
          diff /= 3600
          return (Math.round(diff) + 'h')
        } else {
          diff /= 86400
          return (Math.round(diff) + 'd')
        }
      }
      // IF THERE'S NONE
      return '-'
    },
    formatTooltipOrigin () {
      if (this.hasInternCampaign) {
        // GET MOST RECENT CAMPAIGN
        let internCampaign = this.task.campanhas[0]
        return `<div class="text-left">
        <strong>Campanha:</strong> ${internCampaign.nomeCampanha} <br/>
        <strong>Data de Conversão:</strong> ${internCampaign.dataConversao} <br/>
        <strong>Template:</strong> ${internCampaign.templateModelo} <br/>
        </div>`
      } else if (this.hasUtmCampaign) {
        return `<div class="text-left">
        <strong>Origem:</strong> ${this.task.utmSource} <br/>
        <strong>Campanha:</strong> ${this.task.utmCampaign} <br/>
        <strong>Meio:</strong> ${this.task.utmMedium} <br/>
        <strong>Conteúdo:</strong> ${this.task.utmContent} <br/>
        <strong>Term:</strong> ${this.task.utmTerm}
        </div>`
      } else {
        return (this.task.origemLead && this.task.origemLead.nome) ? this.task.origemLead.nome : 'N/D'
      }
    },
    formatTextOrigin () {
      if (this.hasInternCampaign) {
        return (this.task.origemLead && this.task.origemLead.nome) ? this.task.origemLead.nome : 'N/D'
        // TODO: CHANGE TO CAMPAING NAME AFTER REFACTOR
        // return this.task.campanhas[0].nomeCampanha
      } else {
        return (this.task.origemLead && this.task.origemLead.nome) ? this.task.origemLead.nome : 'N/D'
      }
    }
  }
}
</script>

<style lang="scss">
.icon__green{
  .agendamento__badge__icon{
    color: #04a791;
  }
  .agendamento__badge__text{
    color: #04a791;
  }
}
.teste__botao{
  width: 26px;
  height: 26px;
  color: white;
  background: #6940AB;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.task__card__body{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2px;
  &__inside{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 2px;
  }
}
.task__card__footer{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: .5rem;

    &__avatar__container {
      .task-image {
        &:nth-child(n+2) {
          margin-left: calc(-1rem * var(--n)) !important;
        }
      }
    }

    &__right__container{
      display: flex;
      gap: .25rem;
      align-items: center;
    }
}
.task-description{
  margin-bottom: 0;
  font-size: .75rem;
  text-transform: uppercase;
}
.proximo-agendamento {
  margin-top: 6px;
  background-color: #e9e9e9;
  border-radius: 4px;
  padding: 10px;
  border: solid 1px #dee2e6;
}
.proximo-agendamento-today {
  margin-top: 6px;
  background-color: #75c044;
  border-radius: 4px;
  padding: 10px;
  color: white;
}
.proximo-agendamento-vencido {
  margin-top: 6px;
  background-color: #da3131;
  border-radius: 4px;
  padding: 10px;
  color: white;
}

.ellipsis__name{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/components/TaskCard.vue